var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16406 12.3333L9.4974 9M9.4974 9L12.8307 12.3333M9.4974 9V16.5M16.1641 12.9524C17.182 12.1117 17.8307 10.8399 17.8307 9.41667C17.8307 6.88536 15.7787 4.83333 13.2474 4.83333C13.0653 4.83333 12.8949 4.73833 12.8025 4.58145C11.7158 2.73736 9.70942 1.5 7.41406 1.5C3.96228 1.5 1.16406 4.29822 1.16406 7.75C1.16406 9.47175 1.86027 11.0309 2.98652 12.1613",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadWhite);
export default __webpack_public_path__ + "static/media/uploadWhite.9958f86f99accd974b09b2ed61e46fd0.svg";
export { ForwardRef as ReactComponent };